import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CameraIcon } from '@heroicons/react/24/outline'
import { updateMemberAvatar } from '../../Requests/TeamRequests'
import { getTeamUuid } from '../../utils/cookies'

function MemberAvatar({ member, onUploaded, size = "h-11 w-11", textSize = "text-sm" }) {
    const fileInput = useRef(null)
    const [uploading, setUploading] = useState(false)
    const { t } = useTranslation()

    const handleFile = (event) => {
        const file = event.target.files[0]
        if (!file) return
        setUploading(true)
        updateMemberAvatar(getTeamUuid(), member.uuid, file).then((res) => {
            onUploaded && onUploaded(member.uuid, res.data.avatar_url)
        }).catch(() => {
        }).finally(() => {
            setUploading(false)
            event.target.value = ""
        })
    }

    return (
        <div className={'relative shrink-0 ' + size}>
            {member.avatar_url
                ? <img src={member.avatar_url} alt={member.name || member.email} className={'rounded-full object-cover ' + size} />
                : <div className={`flex items-center justify-center rounded-full bg-black font-semibold text-white ${size} ${textSize}`}>
                    {(member.name || member.email || "?").charAt(0).toUpperCase()}
                </div>
            }
            <button
                type='button'
                title={t('Team.TeamMemberTable.UploadPicture')}
                disabled={uploading}
                onClick={() => fileInput.current?.click()}
                className='absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50'
            >
                <CameraIcon className='h-3.5 w-3.5' />
            </button>
            <input
                ref={fileInput}
                type='file'
                accept='image/png,image/jpeg,image/webp'
                className='hidden'
                onChange={handleFile}
            />
        </div>
    )
}

export default MemberAvatar
